import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Docs from '/src/_includes/braintree-note.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Docs mdxType="Docs" />
    <h1 {...{
      "id": "vault-payment-configuration"
    }}>{`Vault payment configuration`}</h1>
    <p>{`You need to configure the main parameters of the vault implementation in the `}<inlineCode parentName="p">{`config.xml`}</inlineCode>{` file of your payment method module:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`model`}</inlineCode>{` - instance of the vault payment implementation, `}<a parentName="p" {...{
            "href": "vault-di.md"
          }}>{`configured in `}<inlineCode parentName="a">{`di.xml`}</inlineCode></a>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`title`}</inlineCode>{` - vault payment method title; can be overwritten in the store configuration.`}</p>
      </li>
    </ul>
    <p>{`These parameters are specified in the section defined by the unique vault implementation code. They are the minimum required to create vault payment. All other payment settings are inherited from the payment provider integration.`}</p>
    <p>{`Additional configuration might be required depending on your implementation.`}</p>
    <p>{`The following example is the `}<inlineCode parentName="p">{`config.xml`}</inlineCode>{` file of the Braintree payment method:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<config xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="urn:magento:module:Magento_Store:etc/config.xsd">
    <default>
        <payment>
            <braintree>
                <model>BraintreeFacade</model>
                ...
            </braintree>
            <braintree_cc_vault>
                <model>BraintreeCreditCardVaultFacade</model>
                <title>Stored Cards (Braintree)</title>
            </braintree_cc_vault>
        </payment>
    </default>
</config>
`}</code></pre>
    <p>{`In this example `}<inlineCode parentName="p">{`braintree_cc_vault`}</inlineCode>{` is the unique payment code of the vault implementation for Braintree.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      